import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useRouteError } from 'react-router';
import { IcSearch, IcWarning } from 'components/common/icons/EmojiIcons';
import { Button } from 'components/ds';
import styles from './NotFound.module.css';

export const NotFound = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const error = useRouteError() as { status?: number; statusText?: string; message?: string } | undefined;

    const status = error?.status;
    const isNotFound = !error || status === 404;

    // 외부 deeplink (카카오맵 공유 등) 진입 시 dokocrew_native 가 URL 을 늦게 inject 하면
    // 첫 라우트 매칭에 NotFound 가 잠깐 표시될 수 있음. 600ms 동안 본문 표시 지연 →
    // 그 사이 redirect 되면 사용자는 깜빡임 없이 정상 화면 진입.
    const [showContent, setShowContent] = useState(false);
    useEffect(() => {
        const t = setTimeout(() => setShowContent(true), 600);
        return () => clearTimeout(t);
    }, []);

    // 딥링크가 늦게 주입되는 동안 잠깐 이 화면이 스치는 걸 막습니다
    if (!showContent) return <div className={styles.wrap} />;

    return (
        <div className={styles.wrap}>
            <span className={styles.icon}>
                {isNotFound ? <IcSearch size={40} /> : <IcWarning size={40} />}
            </span>
            <h1 className={styles.title}>
                {isNotFound ? t('notFound.notFoundTitle') : t('notFound.errorTitle')}
            </h1>
            <p className={styles.desc}>
                {isNotFound ? t('notFound.notFoundDesc') : t('notFound.errorDesc')}
            </p>
            <div className={styles.actions}>
                <Button variant="primary" size="lg" block onClick={() => navigate('/home', { replace: true })}>
                    {t('notFound.goHome')}
                </Button>
                <Button variant="ghost" size="lg" block onClick={() => navigate(-1)}>
                    {t('notFound.prevPage')}
                </Button>
            </div>
        </div>
    );
};
